export default "__VITE_ASSET__DU$eQUfL__"